type QuickApplyInput = {
  quickApplyCriteria: {
    candidateId: string;
    quickApply: boolean;
    profession: string;
    specialties: string[];
    locations: string[];
    cityLocation: string[];
  } | null;
  locationData: {
    states?: string;
    city?: string;
  } | null;
  specsWithRelSpecs: string[] | null;
  isFilterByQuickApplyEligibility: boolean;
  specialty: string[];
};

export type EligibleData = {
  eligibleSpecialties: string;
  eligibleLocations: string;
  eligibleCityLocations: string;
} | null;

const concatValues = (criteriaObj: string[]): string => {
  return criteriaObj.length > 0 ? criteriaObj.filter((c) => c !== "").join(",") : "";
};

const FilterQuickApplyCriteria = ({
  quickApplyCriteria,
  locationData,
  specsWithRelSpecs,
  isFilterByQuickApplyEligibility,
  specialty,
}: QuickApplyInput): EligibleData => {
  try {
    if (!isFilterByQuickApplyEligibility || !quickApplyCriteria) {
      return null;
    }

    let eligibleSpecialties = "";
    let eligibleLocations = "";
    let eligibleCityLocations = "";

    if (!quickApplyCriteria?.quickApply) {
      return {
        eligibleSpecialties,
        eligibleLocations,
        eligibleCityLocations,
      };
    }

    const specialties = quickApplyCriteria?.specialties ?? [];
    const cityLocation = quickApplyCriteria?.cityLocation ?? [];
    const queryStates = locationData?.states?.split(",") ?? [];
    const queryCities = locationData?.city?.split(",") ?? [];

    const relatedSpecialties: string[] = specsWithRelSpecs
      ? [...Object.values(specsWithRelSpecs).flat()]
      : [];

    const specialtiesDetails: string[] = [...specialty, ...relatedSpecialties];

    // Filter specialties
    if (specialtiesDetails.length > 0) {
      eligibleSpecialties = concatValues(specialties.filter((s) => specialtiesDetails.includes(s)));
    }

    // Filter locations based on state
    if (eligibleSpecialties && queryStates.length > 0) {
      eligibleLocations = concatValues(cityLocation.filter((state) => queryStates.includes(state)));
    } else if (eligibleSpecialties && queryCities.length === 0) {
      eligibleLocations = concatValues(cityLocation);
    }
    // city selected
    if (eligibleSpecialties && queryCities.length > 0) {
      eligibleCityLocations = concatValues(cityLocation);
    }

    return {
      eligibleSpecialties,
      eligibleLocations,
      eligibleCityLocations,
    };
  } catch (error) {
    console.error("Error in FilterQuickApplyCriteria:", error);
    return null;
  }
};

export default FilterQuickApplyCriteria;
